
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/directions/[name]",
      function () {
        return require("private-next-pages/directions/[name]/index.tsx");
      }
    ]);
  